"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * No-operation dummy renderer. Used for audio only.
 */
var NoopRenderer = /** @class */ (function () {
    function NoopRenderer() {
    }
    /**
     * @inheritDoc
     */
    NoopRenderer.prototype.appendContent = function (element) {
        //noop
    };
    /**
     * @inheritDoc
     */
    NoopRenderer.prototype.appendSuggest = function (element) {
        //noop
    };
    /**
     * @inheritDoc
     */
    NoopRenderer.prototype.render = function (message, containerType) {
        return [];
    };
    NoopRenderer.prototype.init = function (channelId) {
    };
    return NoopRenderer;
}());
exports.NoopRenderer = NoopRenderer;
